import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../redux/actions/ApplicationAction";
import notify from "../../../Notifcation";
import { useNavigate } from "react-router-dom";

const Gass = () => {
  const [desc, setdesc] = useState("");
  const [Nationalid, setNationalid] = useState([]);
  const [ChoseMain, setChoseMain] = useState("");
  const [sanadmilk, setsanadmilk] = useState("");
  const [Makee, setMakee] = useState("");
  const [Togare, setTogare] = useState("");
  const [Lecc, setLecc] = useState("");
  const [TaxCard, setTaxCard] = useState("");
  const [sadadtamen, setsadadtamen] = useState("");
  const [sadadtakle, setsadadtakle] = useState("");
  const [khetab, setkhetab] = useState("");
  const [Madkhal, setMadkhal] = useState("");
  const [Homenum, setHomenum] = useState("");
  const [TypeDoc, setTypeDoc] = useState("");
  const [marafic, setmarafic] = useState("");
  const [Others, setOthers] = useState([]);
  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handleFileChangeNational = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalid(files);
  };

  const handleFileChangeOther = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      Nationalid === "" ||
      ChoseMain === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 8);
    formData.append("transaction_company", 'gas');
    formData.append("transaction_type", ChoseMain);
    // formData.append("transaction_category", ChoseSub);
    formData.append("transaction_details", desc);
    formData.append("transaction_apartment_number ", Madkhal);
    formData.append("transaction_building_entrance_number ", Homenum);
    formData.append("title_deed", sanadmilk);
    formData.append("license", Lecc);
    formData.append("tax_card", TaxCard);
    formData.append("commercial_register ", Togare);
    formData.append("industrial_register ", Makee);
    formData.append("collection_letter ", khetab);
    formData.append("necessary_costs ", sadadtakle);
    formData.append("insurance_payment ", sadadtamen);
    formData.append("facilities_receipt", marafic);
    Nationalid.map((item) => {
      return formData.append("client_national_ids", item);
    });
    Others.map((item) => {
      return formData.append("others", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setdesc("");
    setNationalid("");
    setOthers("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">خدمات الكهرباء</h3>
      <div className="inputs-container">
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الطلب
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الطلب
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseMain}
              onChange={(e) => setChoseMain(e.target.value)}
            >
              <MenuItem value={9}>خدمه توصيل الغاز للافراد </MenuItem>
              <MenuItem value={10}>خدمه توصيل الغاز للشركات </MenuItem>
              <MenuItem value={11}>خدمه التوسيعات</MenuItem>
            </Select>
          </FormControl>
        </div>
        {ChoseMain===9?(<> <div className="inp-container ">
          <TextField
            label={"رقم مدخل العمارة"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="text"
            value={Madkhal}
            onChange={(e) => setMadkhal(e.target.value)}
            variant="outlined"
          />
        </div><div className="inp-container ">
          <TextField
            label={"رقم الشقة "}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="text"
            value={Homenum}
            onChange={(e) => setHomenum(e.target.value)}
            variant="outlined"
          />
        </div><div className="inp-container ">
          <TextField
            label={
              <Typography>
                البطاقة الشخصية
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeNational}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"سند الملكية"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setsanadmilk(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"إيصال كهرباء او فاتورة مياة او التلفون الأرضي"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setmarafic(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"تفاصيل"}
            multiline
            type="text"
            value={desc}
            onChange={(e) => {
              setdesc(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"اخرى"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeOther}
            variant="outlined"
          />
        </div></>):ChoseMain===10?(<><div className="inp-container ">
          <TextField
            label={
              <Typography>
                البطاقة الشخصية لصاحب المكان
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeNational}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"سند الملكية"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setsanadmilk(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"إيصال مرافق"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setmarafic(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                   نوع السجل 
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع السجل 
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={TypeDoc}
              onChange={(e) => setTypeDoc(e.target.value)}
            >
              <MenuItem value={'m'}>صناعي</MenuItem>
              <MenuItem value={'t'}>تجاري</MenuItem>
            </Select>
          </FormControl>
        </div>
        {
          TypeDoc==='m'?(
            <div className="inp-container ">
            <TextField
              label={
                "صورة من السجل الصناعي"
              }
              focused
              // inputProps={{
              //   multiple: true,
              // }}
              type="file"
              onChange={(e) => setMakee(e.target.files[0])}
              variant="outlined"
            />
          </div>
           
          ):TypeDoc==='t'?(
            <div className="inp-container ">
            <TextField
              label={
                "صورة من السجل التجاري      "
              }
              focused
              // inputProps={{
              //   multiple: true,
              // }}
              type="file"
              onChange={(e) => setTogare(e.target.files[0])}
              variant="outlined"
            />
          </div>
          ):null
        }
           <div className="inp-container ">
            <TextField
              label={
                "بطاقة ضريبية"
              }
              focused
              // inputProps={{
              //   multiple: true,
              // }}
              type="file"
              onChange={(e) => setTaxCard(e.target.files[0])}
              variant="outlined"
            />
          </div>
          <div className="inp-container ">
            <TextField
              label={
                "الرخصة"
              }
              focused
              // inputProps={{
              //   multiple: true,
              // }}
              type="file"
              onChange={(e) => setLecc(e.target.files[0])}
              variant="outlined"
            />
          </div>
        <div className="inp-container ">
          <TextField
            label={"تفاصيل"}
            multiline
            type="text"
            value={desc}
            onChange={(e) => {
              setdesc(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"اخرى"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeOther}
            variant="outlined"
          />
        </div></>):ChoseMain===11?(<><div className="inp-container ">
          <TextField
            label={
              <Typography>
                البطاقة الشخصية  
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeNational}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"تحصيل من شركة بتروتريد"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setkhetab(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"إيصال سداد التكاليف اللازمة"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setsadadtakle(e.target.files[0])}
            variant="outlined"
          />
        </div>
           <div className="inp-container ">
            <TextField
              label={
                "إيصال سداد التأمين"
              }
              focused
              // inputProps={{
              //   multiple: true,
              // }}
              type="file"
              onChange={(e) => setsadadtamen(e.target.files[0])}
              variant="outlined"
            />
          </div>
        <div className="inp-container ">
          <TextField
            label={"تفاصيل"}
            multiline
            type="text"
            value={desc}
            onChange={(e) => {
              setdesc(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"اخرى"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeOther}
            variant="outlined"
          />
        </div></>):null}
 
        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Gass;
